import { writable } from 'svelte/store';

export interface EventConfirmationData {
    eventId: number;
    thankYouMessage?: string;
}

export const eventConfirmationData = writable<EventConfirmationData | null>(null);

export function setEventConfirmationData(data: EventConfirmationData) {
    eventConfirmationData.set(data);
}

export function clearEventConfirmationData() {
    eventConfirmationData.set(null);
}

